export default {
  loading: false,
  mgmt_departments: [],
  mgmt_department: {},
  totalCount: 0,
};
